import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss'],
})
export class SelectInputComponent implements OnInit {
  @Input() selectOptions: {label: string, value: string}[];
  @Input() form: FormGroup;
  @Input() controlName: string;

  constructor() { }

  ngOnInit() {
  }

}
